// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  projectId: __t.string().name("project_id"),
  orgId: __t.string().name("org_id"),
  timeUs: __t.f64().name("time_us"),
  label: __t.string(),
  color: __t.string(),
  scopeId: __t.string().name("scope_id"),
});
